import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import { ComponentNotificationTitleCreatorUserReleaseUser } from "./types/task-notification.types";
import { getTitleAssignerString } from "./utils/task-notification-title";
import styles from "./task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleCreatorUserReleaseUserProps extends ComponentNotificationTitleCreatorUserReleaseUser {
  read: boolean;
}
export const TaskNotificationTitleCreatorUserReleaseUser = ({
  props: { assignedBy, assignedTo },
  read,
}: TaskNotificationTitleCreatorUserReleaseUserProps) => {
  const { t } = useTranslation();
  const assignedByString = getTitleAssignerString(assignedBy);
  const assignedToString = assignedTo.name;
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {t("hasReleaseTaskCreatedByYouString", {
        assignedBy: assignedByString,
        assignedTo: assignedToString,
      })}
    </div>
  );
};
